module.exports = __webpack_public_path__ + "fonts/cash-market-rounded-regular.6d90b43b.woff2";